var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75C10.2051 9.75 8.75 11.2051 8.75 13C8.75 14.7949 10.2051 16.25 12 16.25C13.7949 16.25 15.25 14.7949 15.25 13C15.25 11.2051 13.7949 9.75 12 9.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2764 4.55279C15.107 4.214 14.7607 4 14.382 4H9.61803C9.23926 4 8.893 4.214 8.72361 4.55279L8.27639 5.44721C8.107 5.786 7.76074 6 7.38197 6H4C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6H16.618C16.2393 6 15.893 5.786 15.7236 5.44721L15.2764 4.55279ZM7.25 13C7.25 10.3766 9.37665 8.25 12 8.25C14.6234 8.25 16.75 10.3766 16.75 13C16.75 15.6234 14.6234 17.75 12 17.75C9.37665 17.75 7.25 15.6234 7.25 13ZM19 10C18.4477 10 18 9.55229 18 9C18 8.44771 18.4477 8 19 8C19.5523 8 20 8.44771 20 9C20 9.55229 19.5523 10 19 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAlt1);
export default __webpack_public_path__ + "static/media/camera-alt-1.61377f7ad151ac2e031755f299bfec3f.svg";
export { ForwardRef as ReactComponent };